// document.addEventListener("DOMContentLoaded", () => {
//   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//   if (isSafari) {
//     document.documentElement.classList.add("is-safari");
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  const isMacSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
    /Macintosh/i.test(navigator.userAgent);
  if (isMacSafari) {
    document.documentElement.classList.add("is-safari");
  }
});
